module.exports = __webpack_public_path__ + "static/media/dialog-image-2.62b3cae9.png";